import React from "react"
import styled from "styled-components"
import { HeadingTwo } from "../elements"

const Partners = ({ slice }) => {
  const { title } = slice.primary

  return (
    <PartnersContainer>
      <HeadingTwo fontSize="36px" textAlign="center">
        {title.text}
      </HeadingTwo>
      <div className="partners-images">
        {slice.items.map(({ image, link }, i) => {
          if (link.url) {
            return (
              <a href={link.url} target="_blank">
                <span className="visually-hidden">{image.alt}</span>
                <img src={image.url} alt={image.alt} key={i}></img>
              </a>
            )
          } else {
            return <img src={image.url} alt={image.alt} key={i}></img>
          }
        })}
      </div>
    </PartnersContainer>
  )
}

export default Partners

const PartnersContainer = styled.section`
  padding: 62px 0 94px 0;

  .partners-images {
    max-width: 1407px;
    width: 100%;
    margin: 50px auto 0 auto;
    grid-gap: 20px 80px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    place-items: center;

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
`
